import ShowAlt from "@/assets/icons/show-alt";
import HideAlt from "@/assets/icons/hide-alt";
import { StatusEnum } from "@/enum/status";

interface StatusInfo {
  title: string;
  icon: React.ReactNode;
  id: string;
  updateTo: StatusEnum;
}

const statusFormat = (status: StatusEnum): StatusInfo => {
  const statusMap: Record<StatusEnum, StatusInfo> = {
    [StatusEnum.ACTIVE]: {
      title: "Desabilitar",
      icon: <HideAlt color={"black"} size={13} />,
      id: "disable",
      updateTo: StatusEnum.INACTIVE,
    },
    [StatusEnum.INACTIVE]: {
      title: "Habilitar",
      icon: <ShowAlt color={"black"} size={13} />,
      id: "enable",
      updateTo: StatusEnum.ACTIVE,
    },
    [StatusEnum.PENDING]: {
      title: "Habilitar",
      icon: <ShowAlt color={"black"} size={13} />,
      id: "enable",
      updateTo: StatusEnum.ACTIVE,
    },
  };

  return statusMap[status] || statusMap[StatusEnum.ACTIVE];
};
export default statusFormat;
